import React, { useState, useEffect, useRef } from 'react';

export function EmployeeSearchSelect({ value, employees, onChange, placeholder, dataId }) {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState(value || '');
    const containerRef = useRef(null);

    useEffect(() => {
        setSearchTerm(value || '');
    }, [value]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const filtered = employees.filter(e => 
        String(e.id) !== String(dataId) && 
        e.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSelect = (emp) => {
        onChange(emp.name, emp.phone);
        setIsOpen(false);
    };

    const handleTextChange = (val) => {
        setSearchTerm(val);
        onChange(val, null);
    };

    return (
        <div className="employee-search-select" ref={containerRef}>
            <div 
                className={`search-select-input-container ${isOpen ? 'open' : ''}`}
                onClick={() => setIsOpen(true)}
            >
                <input 
                    className="employee-edit-field no-border" 
                    value={searchTerm}
                    onChange={e => {
                        handleTextChange(e.target.value);
                        if (!isOpen) setIsOpen(true);
                    }}
                    onFocus={() => setIsOpen(true)}
                    placeholder={placeholder}
                />
                <span 
                    className="search-select-arrow" 
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsOpen(!isOpen);
                    }}
                >
                    {isOpen ? '▲' : '▼'}
                </span>
            </div>
            {isOpen && filtered.length > 0 && (
                <div className="search-select-dropdown">
                    {filtered.map(emp => (
                        <div key={emp.id} className="search-select-option" onClick={(e) => {
                            e.stopPropagation();
                            handleSelect(emp);
                        }}>
                            <div className="option-info">
                                <span className="option-name">{emp.name}</span>
                                <span className="option-role">{emp.category_name}</span>
                            </div>
                            {emp.phone && <span className="option-phone">📱 {emp.phone}</span>}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
